var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 1.4375L9.5 9.4375L1.5 17.4375","stroke":"#3D5265","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRight.defaultProps = {"width":"11","height":"19","viewBox":"0 0 11 19","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
